import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminContractSwitches = lazy(() => import("@/pages/admin/AdminContractSwitches"));

export const Route = createFileRoute("/admin/avtalsbyten")({
  validateSearch: (search: Record<string, unknown>) => ({
    order: typeof search["order"] === "string" ? (search["order"] as string) : undefined,
  }),
  component: () => <AdminContractSwitches />,
});
